<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="[]"
      :items="orkoData?.data"
      :product-options="['oem', 'fleet', 'dispenser']"
      show-date
      date-option-type="datetime"
      :filter-names="filterNames"
      search-label="search"
      :show-data-table="false"
      vertical-scroll
      @filterOption="onFiltersChange"
    >
      <!-- :export-options="['csv', 'excel']"
      @isExport="downloadFile" -->
      <!-- <template #dataTable> -->
      <template #description>
        <div class="logs-datatable-wrapper">
          <div>
            <log-sections
              :loading="isLoading"
              :headers="orkoData?.headers"
              :items="orkoData?.data"
            >
              <template #sub-title>
                <!-- <div v-if="list?.orko_qty_sum"> -->
                <div>
                  <div>
                    <span>Total Qty: &nbsp;</span>
                    <span class="value">{{ list?.orko_qty_sum }}</span>
                  </div>
                </div>
              </template>
            </log-sections>
          </div>
          <div>
            <log-sections
              :loading="isLoading"
              :title="'tenant'"
              :headers="tenantData?.headers"
              :items="tenantData?.data"
            >
              <template #sub-title>
                <span>
                  <div
                    v-if="list"
                    class="d-flex flex-column gap5"
                  >
                    <div class="d-flex justify-end">
                      <span>Total Qty: &nbsp;</span>
                      <span class="value">{{ list?.tenant_qty_sum }}</span>
                    </div>
                    <div class="d-flex gap5">
                      <div>
                        <span>Diff Ltr: &nbsp;</span>
                        <span class="value">{{ list?.diff_in_litre }},</span>
                      </div>
                      <div>
                        <span>Diff in %: &nbsp;</span>
                        <span class="value">{{ list?.percentage }}</span>
                      </div>
                    </div>
                  </div>
                </span>
              </template>
            </log-sections>
          </div>
        </div>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.terminal_id"
            filled
            dense
            clearable
            :items="terminalList"
            item-value="id"
            item-text="name"
            :label="$t('terminal')"
            @change="onTerminalChange"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.dispenser_id"
            filled
            dense
            clearable
            :items="dispenserList"
            item-value="id"
            item-text="dispenser_identifier"
            :label="$t('dispenser')"
            @change="onDispenserChange"
          />
        </v-card>
        <!-- <v-card>
          <v-select
            v-model="customFilters.nozzle_id"
            filled
            dense
            clearable
            :items="nozzleList"
            item-value="id"
            :item-text="(n) => n.display_name || n.nozzle_number"
            :label="$t('nozzle_number')"
            @change="fetchData"
          />
        </v-card> -->
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <!-- <template #actionModals>
       
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { debounce } from "lodash";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    LogSections: () => import("./utils/Log-Sections.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      permissions: {
        view: "dispensers.list",
        create: "dispensers.list",
        edit: "dispensers.list",
        delete: "dispensers.list",
      },

      //
      customFilters: {},

      filters: {},
      subFilters: {},

      //
      nozzleList: [],
      //
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "dataLogs/getLoading",
      meta: "dataLogs/getMeta",
      list: "dataLogs/getComparisonData",
      //
      terminalList: "terminal/getTerminalDropDown",
      dispenserList: "fuelDispenser/getList",
    }),
    orkoData() {
      const params = {
        headers: ["date_time", "bus_no", "session_id", "qty"],
        data: this.list?.orko_sessions || [],
      };
      return params;
    },
    tenantData() {
      const params = {
        headers: ["date_time", "bus_no", "qty"],
        data: [],
      };
      const d = this.list?.tenant_sessions || [];
      if (d.length > 0) {
        d.forEach((el) => {
          params.data.push({
            ...el,
            date_time: el.filling_datetime,
            qty: el.total_diesel,
          });
        });
      }
      return params;
    },
    filterNames() {
      return [""];
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        if (v) {
          this.$store.dispatch("terminal/dropDownList", { tenant_id: v });
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
          this.$store.commit("fuelDispenser/SET_LIST", []);

          this.customFilters = {};
        }
      },
    },
    "options.fleetId": {
      handler: function (v) {
        if (v) {
          this.$store.dispatch("terminal/dropDownList", { tenant_id: v });
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
          this.$store.commit("fuelDispenser/SET_LIST", []);

          this.customFilters = {};
        }
      },
    },
    options() {
      this.fetchData();
    },
  },
  async mounted() {
    this.getTerminal();

    if (this.$route?.query?.terminal_id) {
      this.customFilters.terminal_id = parseInt(this.$route.query.terminal_id);
      await this.getDispenser(this.customFilters.terminal_id);
    }
    if (this.$route?.query?.dispenser_id) {
      this.customFilters.dispenser_id = parseInt(
        this.$route.query.dispenser_id
      );
      this.getNozzles(this.customFilters.dispenser_id);
    }
    if (this.$route?.query?.nozzle_id) {
      this.customFilters.nozzle_id = parseInt(this.$route.query.nozzle_id);
    }

    this.fetchData();
  },
  beforeDestroy() {
    const params = {
      name: "logs_comparison",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    fetchData: debounce(async function () {
      const params = { ...this.options, ...this.customFilters };
      await this.$store
        .dispatch("dataLogs/comparisonLogs", params)
        .then((res) => {
          const msg = res.body?.message;
          const isOrko = res.body?.is_orko_qty_greater;
          if (msg) {
            this.$store.dispatch("alerts/error", msg);
          } else if (isOrko == 0) {
            this.$store.dispatch("alerts/info", "Orko quantity is less");
          } else if (isOrko == 1) {
            this.$store.dispatch("alerts/info", "Orko quantity is greater");
          } else if (isOrko == -1) {
            this.$store.dispatch("alerts/info", "Both quantites are equal");
          }

          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    }, 1500),
    //
    async getTerminal() {
      if (!this.authUser.isAdmin) {
        const tId = this.authUser?.independent_fleet_user_nature
          ? this.authUser.tenant_id
          : this.authUser.parent_tenant_id;
        const params = { tenant_id: tId };
        await this.$store.dispatch("terminal/dropDownList", params);
      }
    },
    async getDispenser(v) {
      if (v) {
        const params = { terminal_id: v };
        await this.$store.dispatch("fuelDispenser/list", params);
      } else {
        this.$store.commit("fuelDispenser/SET_LIST", []);
      }
    },
    async getNozzles(v) {
      if (v) {
        const dRow = this.dispenserList.find((r) => r.id === v);
        this.nozzleList = dRow?.nozzles;
        // await this.$store.dispatch(
        //   "dataLogs/busNoDropdown",
        //   this.customFilters
        // );
      } else {
        // this.$store.commit("dataLogs/SET_BUS_LIST", []);
        this.nozzleList = [];
      }
    },

    //
    async onTerminalChange(v) {
      delete this.customFilters.dispenser_id;
      delete this.customFilters.nozzle_id;
      await this.getDispenser(v);
      this.fetchData();
    },

    async onDispenserChange(v) {
      delete this.customFilters.nozzle_id;
      await this.getNozzles(v);
      this.fetchData(v);
    },
    //
  },
};
</script>
<style lang="sass" scoped>
#regular-tables
  display: flex
  flex-direction: column
:deep .Desc
  order: 3 !important
.value
  font-weight: 600

.logs-datatable-wrapper
  display: flex
  gap: 1rem
  > div
    flex: 1
</style>
